import gql from 'graphql-tag';
import xaxios from '@/xaxios';
import { getUserData,setAccessToken } from '@/accessToken.js'  

export const headers = [
  { text: 'concepto', value: 'nombre' },
  { text: 'nro. de cuota', value: 'nro_cuota' },
  { text: 'monto', value: 'monto' },
  { text: 'plazo de pago', value: 'fecha_pago' },
  // { text: '', value: 'num_cuota_grupo' },
];

const idcuota_concepto = 375; // hardcodedado, pero no deberia en prod => 373
export const id_concepto_cuota = 312;
export const concepto_ids_orden = [idcuota_concepto, 1, 314, 312, 172, 2, 3];

const round2 = (num) => Math.round((num + Number.EPSILON) * 100) / 100;
const fecha_str = (fecha, offset = 0) => {
  const f = new Date(fecha);
  f.setMonth(f.getMonth() + offset);

  const dia = String(f.getDate()).padStart(2, '0');
  const mes = String(f.getMonth() + 1).padStart(2, '0');
  const año = f.getFullYear();

  return `${dia}/${mes}/${año}`;
};
const formatearfecha = (iso) => {
  const [year, month, day] = iso.split('T')[0].split('-');
  const formateada = `${day}/${month}/${year}`;
  return formateada;
};

const isanterior = (iso) => {
  const fecha = new Date(iso);
  const limite = new Date(2025, 11, 31, 23, 59, 59, 999); // 31 dic 2025

  const esMenor = fecha < limite;
  window.console.log('antes:', fecha, limite, esMenor);

  return esMenor;
};

const parseLabel2 = (option) => {
  if (option == null) return '';
  var seg = option.seg_apellido;
  if (seg == null) seg = '';
  return option.nombres + ' ' + option.pri_apellido + ' ' + seg + ' -- Doc: ' + option.num_doc;
};

export const rowClassX = (item, incluir_deuda_q10_in_plan) => {
  if (!incluir_deuda_q10_in_plan && item.concepto_id == idcuota_concepto) return 'grupo-q10';
  return item._grupo_color % 2 == 0 ? 'grupo-par' : 'grupo-impar';
};

export const planConGruposComputed = (plan) => {
  if (!plan) return [];
  let lastDate = null;
  let groupIndex = 0;

  return plan.map((item) => {
    if (item.fecha_pago !== lastDate) {
      groupIndex++;
      lastDate = item.fecha_pago;
    }

    return {
      ...item,
      _grupo_color: groupIndex,
    };
  });
};

export const buscar_persona = async (thiz, query) => {
  const sql = gql`query{ getPersonasSearchNameOrNumDoc(text:"${query}",cursor: 10000000, estado: true){id,num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,contacto}}`;
  const res = await thiz.$apollo
    .query({ query: sql })
    .then((data) => data)
    .catch((e) => e);
  if (res && res.data) {
    const datas = res.data.getPersonasSearchNameOrNumDoc;
    datas.forEach((x) => (x.nombre = parseLabel2(x)));
    return datas;
  }
  return [];
};

export const getprograma = async (id) => {
  const url = `${process.env.VUE_APP_API_REST}/esam/programa/id/` + id;
  const res = await xaxios.get(url);
  return res.data;
};

export const getpromociones = async (idprograma) => {
  const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/promociones/programa/${idprograma}/aprobado`;
  const res = await xaxios
    .get(url)
    .then(({ data }) => data)
    .catch((e) => e);
  return res;
};

export const cambiar_a_inscrito = async (yo, estudiante, programa, plan_seleccionado, plan_pagos, extras) => {
  /* const plan_pagos = [
        {
            cobro_programa_id: 1,
            fecha_pago: "03/02/2026",
            monto: 1,
            nro_cuota: 1,
        }
    ] */
  const input = {
    tipo_pago: true,
    asesor_id: extras.asesor_id,
    estudiante_id: estudiante.id,
    inscripcion_id: extras.inscripcion_id,
    plan_cobro_programa_id: plan_seleccionado.plan_cobro_programa_id,
    programa_id: programa.programa_id,
    registrado_por: yo.id,
    plan_pagos: plan_pagos,
  };

  // window.console.log('input', input);
  const url = `${process.env.VUE_APP_API_REST}/api/esam/preinscripcion`;
  try {
    const { data } = await xaxios.put(url, input);
    return data;
  } catch (e) {
    return e.response.data;
  }
};

export const generar_plan = (inp, promo, cobros, deuda_q10) => {
  // primero sacamos la el concepto deuda y operamos con los demas
  const numero_cuotas = inp.numero_cuotas_total;
  const deuda_anterior = cobros.filter((x) => x.concepto_id == idcuota_concepto);
  cobros.map(x=>{
    x.monto = Number(x.monto)
  })
  cobros = cobros.filter((x) => x.concepto_id != idcuota_concepto);

  const cuota = cobros.find((x) => x.concepto_id == id_concepto_cuota);
  if (cuota) cuota.monto = cuota.monto * inp.numero_materias_total;

  const prioridad = new Map(concepto_ids_orden.map((id, index) => [id, index]));
  cobros.sort((a, b) => {
    return (prioridad.get(a.concepto_id) ?? Infinity) - (prioridad.get(b.concepto_id) ?? Infinity);
  });

  window.console.log('cobritos::', cobros, inp);

  let plan_con_descuentos = null;
  if (promo && promo.detalle_promocion) {
    promo.detalle_promocion.forEach((p) => {
      const ex = cobros.find((c) => c.concepto_id == p.concepto_pago_id);
      if (ex) {
        let desc = 0;
        if (p.is_porcentaje) desc = ex.monto * (parseInt(p.valor_descuento) / 100);
        else desc = p.valor_descuento;
        ex.monto -= desc;
        ex.promo_descuento = `${p.valor_descuento} ${p.is_porcentaje ? '%' : '$'} descuento`;
      }
    });
    plan_con_descuentos = JSON.parse(JSON.stringify(cobros));
  }

  let monto_total = 0;
  let submonto_base = 0;
  cobros.forEach((x) => {
    monto_total += x.monto;
  });
  monto_total = round2(monto_total);
  submonto_base = submonto_base = round2(monto_total / numero_cuotas);

  let pendientes = cobros.map((c) => ({
    ...c,
    pendiente: round2(c.monto),
  }));

  let plan = [];
  let banderin = null;
  let num_cuota = 1;
  let index = 0;
  let fecha_pago = new Date();
  fecha_pago.setMonth(0);
  fecha_pago.setDate(15);

  for (let cuota = 1; cuota <= numero_cuotas; cuota++) {
    let submonto = submonto_base;

    for (const cobro of pendientes) {
      const id_c = cobro.concepto_id;
      if (submonto <= 0 && id_c != idcuota_concepto) break;
      if (cobro.pendiente <= 0 && id_c != idcuota_concepto) continue;
      if (num_cuota > 1 && banderin != cobro.concepto_id) {
        num_cuota = 1;
      }
      banderin = cobro.concepto_id;

      const pago = round2(Math.min(submonto, cobro.pendiente));

      cobro.pendiente = round2(cobro.pendiente - pago);
      submonto = round2(submonto - pago);

      plan.push({
        cobro_programa_id: cobro.cobro_programa_id,
        fecha_pago: fecha_str(fecha_pago, cuota-1),
        monto: pago,
        nro_cuota: num_cuota++,
        //
        index: index++,
        concepto_id: cobro.concepto_id,
        nombre: cobro.nombre,
        num_cuota_grupo: cuota,
        promo_descuento: cobro.promo_descuento,
      });
    }
  }

  // aqui volvemos a agregar la deuda como primer concepto
  // con el total de la deuda, sin ser alterada por la division de cuotas
  if (deuda_q10 && deuda_q10.Total_pendiente) {
    window.console.log('deuda_q10:', deuda_q10);
    window.console.log('cobros:', cobros);

    let fecha_pago = new Date();
    fecha_pago.setMonth(0);
    fecha_pago.setDate(15);

    const deuda = deuda_anterior[0];
    deuda.nro_cuota = 1;
    deuda.fecha_pago = fecha_str(fecha_pago, 0);
    deuda.monto = deuda_q10.Total_pendiente;
    plan.unshift(deuda);
  } else {
    plan = plan.filter((x) => x.concepto_id != idcuota_concepto);
  }
  plan = plan.filter((x) => x.monto > 0);

  window.console.log('plan', plan)

  return {
    plan,
    plan_con_descuentos,
    monto_total,
    submonto_base,
  };
};

export const generar_plan_bloque = (inp, promo, cobros, deuda_q10, thiz) => {
  // primero sacamos la el concepto deuda y operamos con los demas
  const id_cuota_concepto = 312;
  const numero_cuotas = inp.numero_cuotas_total;
  const deuda_anterior = cobros.filter(x=>x.concepto_id == idcuota_concepto);
  const cuotas_conceptos = cobros.filter((x) => x.concepto_id == id_cuota_concepto);
  cobros = cobros.filter((x) => x.concepto_id != idcuota_concepto);
  cobros = cobros.filter((x) => x.concepto_id != id_cuota_concepto);

  const cuota = cobros.find((x) => x.concepto_id == id_concepto_cuota);
  if (cuota) cuota.monto = cuota.monto * inp.numero_materias_total;

  const prioridad = new Map(concepto_ids_orden.map((id, index) => [id, index]));
  cobros.sort((a, b) => {
    return (prioridad.get(a.concepto_id) ?? Infinity) - (prioridad.get(b.concepto_id) ?? Infinity);
  });

  window.console.log('cobritos bloque::', cobros, inp, cuotas_conceptos);

  let plan_con_descuentos = null;
  if (promo && promo.detalle_promocion) {
    promo.detalle_promocion.forEach((p) => {
      const ex = cobros.find((c) => c.concepto_id == p.concepto_pago_id);
      if (ex) {
        let desc = 0;
        if (p.is_porcentaje) desc = ex.monto * (parseInt(p.valor_descuento) / 100);
        else desc = p.valor_descuento;
        ex.monto -= desc;
        ex.promo_descuento = `${p.valor_descuento} ${p.is_porcentaje ? '%' : '$'} descuento`;
      }
    });
    plan_con_descuentos = JSON.parse(JSON.stringify(cobros));
  }

  let monto_total = 0;
  let submonto_base = 0;
  cobros.forEach((x) => {
    monto_total += x.monto;
  });
  monto_total = round2(monto_total);
  submonto_base = submonto_base = round2(monto_total / numero_cuotas);

  let pendientes = cobros.map((c) => ({
    ...c,
    pendiente: round2(c.monto),
  }));

  let plan = [];
  let banderin = null;
  let num_cuota = 1;
  let index = 0;
  let fecha_pago = new Date();
  fecha_pago.setMonth(0);
  fecha_pago.setDate(15);

  for (let cuota = 1; cuota <= numero_cuotas; cuota++) {
    let submonto = submonto_base;

    for (const cobro of pendientes) {
      const id_c = cobro.concepto_id;
      if (submonto <= 0 && id_c != idcuota_concepto) break;
      if (cobro.pendiente <= 0 && id_c != idcuota_concepto) continue;
      if (num_cuota > 1 && banderin != cobro.concepto_id) {
        num_cuota = 1;
      }
      banderin = cobro.concepto_id;

      const pago = round2(Math.min(submonto, cobro.pendiente));

      cobro.pendiente = round2(cobro.pendiente - pago);
      submonto = round2(submonto - pago);

      plan.push({
        cobro_programa_id: cobro.cobro_programa_id,
        fecha_pago: fecha_str(fecha_pago, cuota-1),
        monto: pago,
        nro_cuota: num_cuota++,
        //
        index: index++,
        concepto_id: cobro.concepto_id,
        nombre: cobro.nombre,
        num_cuota_grupo: cuota,
        promo_descuento: cobro.promo_descuento,
      });
    }
  }

  // aqui volvemos a agregar la deuda como primer concepto
  // con el total de la deuda, sin ser alterada por la division de cuotas
  if (deuda_q10 && deuda_q10.Total_pendiente) {
    window.console.log('deuda_q10:', deuda_q10);
    window.console.log('cobros:', cobros);

    const concepto_cuota = cuotas_conceptos[0];
    let deuda_pendiente = 0;
    let numerito = 1;
    deuda_q10.Cuotas.forEach((x) => {
      const item = {};
      item.cobro_programa_id = concepto_cuota.cobro_programa_id;
      item.fecha_pago = formatearfecha(x.Fecha_cuota);
      item.monto = x.Pendiente;
      item.nro_cuota = numerito;
      //
      item.concepto_id = concepto_cuota.concepto_id;
      item.nombre = concepto_cuota.nombre;

      if( !isanterior(x.Fecha_cuota) && x.Pendiente ){
        plan.push(item);
        numerito++
      }else{
        deuda_pendiente += item.monto
      }
    });

    let fecha_pago = new Date();
    fecha_pago.setMonth(0);
    fecha_pago.setDate(15);

    const deuda = deuda_anterior[0];
    if(deuda){
      deuda.nro_cuota = 1;
      deuda.fecha_pago = fecha_str(fecha_pago, 0);
      deuda.monto = deuda_pendiente;
    }else{
      thiz.$root.$notify.show('no hay el concepto de deuda anterior', { color: 'red', x: 'right' });
    }
    plan.unshift(deuda);

  } else {
    plan = plan.filter((x) => x.concepto_id != idcuota_concepto);
  }
  plan = plan.filter((x) => x.monto > 0);

  // volver a ordenar ya que la deuda se ingresa con push y queda al final
  plan.sort((a, b) => {
    return (prioridad.get(a.concepto_id) ?? Infinity) - (prioridad.get(b.concepto_id) ?? Infinity);
  });

  return {
    plan,
    plan_con_descuentos,
    monto_total,
    submonto_base,
  };
};

export const body_cambio_plan = async (data) => { 
  const ex = getUserData(); 
  if( ex ){  
    const u = JSON.parse(ex);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const raw = JSON.stringify({ username: u.user, password: u.clave });
    const requestOptions = { method: 'POST', headers: myHeaders, body: raw };
    const rr = await fetch(process.env.VUE_APP_AUTH_POST, requestOptions).then((response) => response.json()).then((data)=>data).catch(e=>e)
    if(rr && rr.ok){
      const token = rr.accessToken 
      setAccessToken(token)
    }
  } 

  const url = `${process.env.VUE_APP_API_REST}/api/esam/inscripcion/plan/eliminar`;
  const res = await xaxios.post(url, { inscripcion_id: data.inscripcion_id } ).then((data)=>data).catch(e=>e);

  window.console.log('>>>>res:', res);

  const body = {
    inscripcion_id: data.inscripcion_id,
    programa_id: data.programa_id,
    estudiante_id: data.estudiante_id,
    asesor_id: data.asesor_id,
    registrado_por: data.registrado_por,
    tipo_pago: true, // true  a cuotas, false al contado
    plan_cobro_programa_id: data.plan_cobro_programa_id,
    plan_pagos: data.plan_pagos,
  }

  let urlacademico = `${process.env.VUE_APP_API_REST}/api/esam/inscripcion/generate/plan`;
  const res2 = await xaxios.put(urlacademico, body ).then(({data})=>data).catch(e=>e);
  window.console.log('res2', res2);
  
  return res2;
}
